<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer title="银行卡" >
			<div>
				<span class="text-danger">注：下列银行的借记卡暂不支持</span>
				<div class="ml-5">农业银行借记卡、招商银行借记卡、兴业银行借记卡</div>
		
			</div>	
			<div class="mt-2">
				<b-form>
					<b-form-group id="input-group-1" label="姓名:" label-for="input-1">
						<b-form-input id="input-1" v-model="form.username" type="email" placeholder="" disabled>
						</b-form-input>
					</b-form-group>

					<b-form-group id="input-group-2" label="证件号码:" label-for="input-2">
						<b-form-input id="input-2" v-model="form.idnoMask" placeholder="" disabled></b-form-input>
					</b-form-group>

					<b-form-group id="input-group-2" label="银行卡号:" label-for="input-2">
						<b-form-input id="input-2" v-model="form.bankcard" placeholder="输入银行卡号"></b-form-input>
					</b-form-group>


					<b-form-group id="input-group-2" label="手机号码:" label-for="input-2">
						<b-form-input id="input-2" v-model="form.phone" placeholder="输入手机号码"></b-form-input>
					</b-form-group>

					<b-form-group id="input-group-2" label="短信验证码:" label-for="input-2">
						<div class="d-flex justify-content-between">
							<b-form-input id="input-2" v-model="form.smscode" placeholder="输入短信验证码" class="w-50">
							</b-form-input>

							<b-input-group-append style="font-size: 10px;">
								<b-button variant="outline-success" @click="prebindCard" v-if="ts==60">获取验证码</b-button>
								<b-button variant="outline-secondary" class="" v-else>{{ts}}秒后再获取</b-button>
							</b-input-group-append>
						</div>
					</b-form-group>

				</b-form>

				<div class="d-flex justify-content-end mr-3">
					<b-button  variant="success" class="ml-3" @click="confirmBindCard" v-if="preBind">确认绑卡
					</b-button>
					<b-button  variant="secondary" class="ml-3" @click="hideModal"> 取消</b-button>
					
				<!-- 	<b-button squared variant="secondary" class="ml-3" @click="test"> test</b-button> -->
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				form: {
					bankcard: '',
					username: '',
					phone: "",
					idno: "",
					idnoMask:"",
					smscode: "",
				},
				ts: 60,
				smsTimer: 0,
				requestRefNo: "",
				authSn: "",
				preBind: false,
				callBack:null,
				payType:"",
			}
		},

		methods: {
			showModal(userName, idNo,idnoMask,_call,_payType) {
				this.form.username = userName;
				this.form.idno = idNo;
				this.form.idnoMask = idnoMask;
				this.preBind = false;
				this.callBack=_call;
				this.payType=_payType;
				this.$refs['publish-modal'].show()
			},

			hideModal() {
				this.$refs['publish-modal'].hide()
			},

			isValidBankCard(cardNumber) {
				// 正则表达式验证基本格式，只允许16到19位数字
				const regex = /^(\d{16}|\d{17}|\d{18}|\d{19})$/;
				if (!regex.test(cardNumber)) {
					return false;
				}

				// Luhn算法验证银行卡号
				let sum = 0;
				let shouldDouble = false;

				// 从右到左遍历数字，每隔一位数字翻倍
				for (let i = cardNumber.length - 1; i >= 0; i--) {
					let digit = parseInt(cardNumber.charAt(i));

					if (shouldDouble) {
						digit *= 2;
						if (digit > 9) {
							digit -= 9;
						}
					}

					sum += digit;
					shouldDouble = !shouldDouble;
				}

				// 如果总和可以被10整除，则银行卡号有效
				return sum % 10 === 0;
			},

			validateUSPhoneNumber(phoneNumber) {
				// 创建一个正则表达式
				const phoneRegex = /^1[3-9]\d{9}$/;
				return phoneRegex.test(phoneNumber);
			},

			toast(toaster, append = false) {
				this.counter++
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},
			//330625197302206417 陈槐
			prebindCard(){
				if(this.payType=="sxy"){
					this.prebindCardSxy()
				}else{
					this.prebindCardYc()
				}
			},
			
			prebindCardYc() {
				let that = this;
				if (!this.isValidBankCard(this.form.bankcard)) {
					that.toast("请输入正确的银行卡号")
					return
				}

				if (!this.validateUSPhoneNumber(this.form.phone)) {
					that.toast("请输入正确的手机号码")
					return
				}
				let _openid=localStorage.getItem("_openid")
				
				this.$axios.post(that.$DOMAIN() + "/wechatApi/wechat/card/bindCardPre", {
						"userName": this.form.username,
						"idNo": this.form.idno,
						"mobileNo": this.form.phone,
						"bankCardNo": this.form.bankcard
					}, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						if (response.data.result == "FAIL") {
							that.toast(response.data.failReason)
							return
						} else {
							that.preBind = true;
							that.toast("短信验证码已经成功发送至手机")
							that.requestRefNo = response.data.requestRefNo
							that.authSn = response.data.authSn
						}
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
				});
			},
			
			
			//330625197302206417 陈槐
			prebindCardSxy() {
				let that = this;
				if (!this.isValidBankCard(this.form.bankcard)) {
					that.toast("请输入正确的银行卡号")
					return
				}
			
				if (!this.validateUSPhoneNumber(this.form.phone)) {
					that.toast("请输入正确的手机号码")
					return
				}
				let _openid=localStorage.getItem("_openid")
				
				this.$axios.post(that.$DOMAIN() + "/wechatApi/payease/preBindCard", {
						"userName": this.form.username,
						"idCardNo": this.form.idno,
						"mobileNo": this.form.phone,
						"bankCardNo": this.form.bankcard
					}, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log("ret===>",response.data.data.result)
						if (response.data.data.result == "FAIL") {
							that.toast("短信验证码发送失败,请核对信息是否正确！")
							return
						} else {
							that.preBind = true;
							that.toast("短信验证码已经成功发送至手机")
							that.requestRefNo = response.data.data.fcpTrxNo
						}
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
				});
			},
			
			test(){
				this.callBack()
				this.hideModal()
			},
			//330625197302206417 陈槐
			
			confirmBindCard(){
				if(this.payType=="sxy"){
					this.confirmBindCardSxy()
				}else{
					this.confirmBindCardYc()
				}
			},
			
			confirmBindCardYc() {
				let that = this;
				let _openid=localStorage.getItem("_openid")
				this.$axios.post(that.$DOMAIN() + "/wechatApi/wechat/card/bindCardConfirm", {
						"requestRefNo": this.requestRefNo,
						"authSn": this.authSn,
						"smsCode": this.form.smscode,
						"businessType": "WalletBindCard"
					}, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log(response)
						if (response.data.result == "FAIL") {
							that.toast(response.data.failReason)
							return
						} else {
							that.callBack()
							that.hideModal()
						}
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
				});
			},
			
			confirmBindCardSxy() {
				let that = this;
				let _openid=localStorage.getItem("_openid")
				this.preBind=false;
				this.$axios.post(that.$DOMAIN() + "/wechatApi/payease/confirmBindCard", {
						"fcpTrxNo": this.requestRefNo,
						"kaptchaCode": this.form.smscode,
					}, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log(response)
						if (response.data.result == "FAIL") {
							that.preBind=true;
							that.toast(response.data.failReason)
							return
						} else {
							that.callBack()
							that.hideModal()
						}
					})
					.catch(function(error) {
						that.toast(error.response.data.errmsg)
				});
			},

		}
	}
</script>

<style>

</style>
